export default __webpack_public_path__ + "static/media/icono3gris.88a5f9b1.svg";